import { BaseEntity } from ".";
import { getCachedCharacterEntity } from "./CharacterEntityCache";
import { getCachedTypeEntity } from "./TypeEntityCache";

export class ImplantEntity extends BaseEntity {
  protected _implants: any;
  constructor(id: number, props: any, character_id: any, implants: any) {
    super(id, props);
    this._dataTypeName = "Character Implant Summary";
    this._character_id = character_id;
    this._implants = implants;
  }

  async toJson(): Promise<Excel.EntityCellValue> {
    //const props = this.props;
    var entity = await super.toJson();
    // Properties
    if (entity.properties) {
      delete entity.properties["0"];
      const characterEntity = await getCachedCharacterEntity(this._character_id);
      if (characterEntity !== null) {
        entity.properties["owner"] = await characterEntity.toJson();
      }
      let implant_array: Excel.CellValue[][] = [];
      for (const y of this._implants) {
        const typeEntity = await getCachedTypeEntity(y);
        if (typeEntity) {
          implant_array.push([
            {
              type: Excel.CellValueType.entity,
              text: `${typeEntity.props["name"]}`,
              properties: {
                type: await typeEntity.toJson(),
              },
            },
          ]);
        }
      }
      if (this._implants.length) {
        entity.properties["implants"] = {
          type: Excel.CellValueType.array,
          elements: implant_array,
        };
      }
      entity.text = `${this._implants.length} implants for ${characterEntity?.props["name"]}`;
      entity.properties["name"] = {
        type: Excel.CellValueType.string,
        basicValue: entity.text,
      };
    }
    // Layouts
    entity.layouts = {
      card: {
        title: { property: "name" },
      },
    };
    return entity;
  }
}
